var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseSecure',{attrs:{"idp":[_vm.IDP.IDIR, _vm.IDP.BCEIDBOTH]}},[_c('UserSubmission',{attrs:{"saved":_vm.sv,"submissionId":_vm.s,"readOnly":false,"draft":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }